import { AddRounded, RemoveRounded } from "@mui/icons-material";
import React, { useState, useEffect, useReducer } from "react";
import { actionType } from "../redux/reducer";
import { useStateValue } from "../redux/state_provider";

let cart_items = [];
const CART_ITEM = ({ name, imgSrc, qty, price, itemId }) => {
  const [quantity, setquantity] = useState(1);
  const [{ cart, total }, dispatch] = useStateValue();
  let total_price = total;

    function reducer(state, action){
      if(action.type === 'sum'){
        console.log(action);
        return parseInt(quantity) * parseFloat(action.playload)
      }
    }
    const [item_sum_price, sumDispatch] = useReducer(reducer, price)


  useEffect(() => {
    cart_items = cart;
    sumDispatch({ type: "sum", playload: price})
  }, [quantity, total, cart, price, item_sum_price]);

  function onUpdateQty(action, id) {
    if (action === "add") {
      setquantity(quantity + 1);
      console.log(quantity);
      total_price = parseFloat(total) + parseFloat(price);
      dispatch({
        type: actionType.SET_TOTAL,
        total: total_price,
      });
    } else {
      if (quantity === 1) {
        cart_items = cart_items.filter((item) => item.id !== id);
        dispatch({
          type: actionType.SET_CART,
          cart: cart_items,
        });
        total_price = total - price;
        dispatch({
          type: actionType.SET_TOTAL,
          total: total_price,
        });
      } else {
        setquantity(quantity - 1);
        console.log(quantity);
        total_price = total - price;
        dispatch({
          type: actionType.SET_TOTAL,
          total: total_price,
        });
      }
    }
  }
  console.log(cart);

  return (
    <div className="card_item" id={itemId}>
      <div className="img_box">
        <img src={imgSrc} alt="" />
      </div>

      <div className="item_section">
        <h3 className="item_name">{name}</h3>
        <div className="item_qty">
          <span>X {quantity}</span>
          <div className="qty">
            <RemoveRounded onClick={() => onUpdateQty("remove", itemId)} />

            <AddRounded onClick={() => onUpdateQty("add", itemId)} />
          </div>
        </div>
      </div>
      <p className="item_price">
        <span>$</span>
        {item_sum_price}
      </p>
    </div>
  );
};

export default CART_ITEM;
